export enum ServerResponseCodes {
    Success = 200,
    BadRequest = 400,
    NotFound = 404,
    NotAllowed = 405,
    NotAuthorized = 401,
    Error = 500,
    PaymentRequired = 402,
}

export enum HttpMethod {
    GET = "GET",
    POST = "POST",
    PUT = "PUT",
    DELETE = "DELETE",
    PATCH = "PATCH",
    HEAD = "HEAD",
    OPTIONS = "OPTIONS",
    TRACE = "TRACE",
    CONNECT = "CONNECT",
}

// the endpoint that our client can run queries against
export const nextjsGraphqlProxyPath = "/api/graphql"
